import React from 'react';
import { NavLink } from 'react-router-dom';
// import logo from "../../assets/logo.png";
// import cloudlogo from "../../assets/cloud-logo.png";
import classNames from 'classnames';
import SessionData from './SessionData/SessionComponents';
// import cloneDeep from 'lodash/cloneDeep';

import { Menu, Layout } from 'antd';
import "./SideBar.css";
import 'antd/dist/antd.css';
import { DesktopOutlined, FileSearchOutlined } from '@ant-design/icons';

const { Sider } = Layout;
// const { SubMenu } = Menu;

// const topM = {
//     width: "100%",
//     marginTop: "50px",
// }
let accessType = {
    END_USER :'END_USER',
    CORPORATE : 'CORPORATE',
    ONBOARDING_TEAM : 'ONBOARDING_TEAM'
};

class SideBar extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            openedSubMenus: ["filetrace"],
            openedMenuItems: [],
        }

        this.pushopeneditems = this.pushopeneditems.bind(this);
    }

    pushopeneditems(subMenuArr,menuArr){
        console.log('subMenuArr',subMenuArr,'menuArr',menuArr);
        this.setState({
            openedSubMenus:subMenuArr,
            openedMenuItems:menuArr
        })
    }

    render() {
        alert(JSON.stringify(this.state.openedSubMenus));
        alert(JSON.stringify(this.state.openedMenuItems));
        return (
            <Sider trigger={null} collapsible collapsed={this.props.isOpen}>
                {/* <div className={classNames('logo-wrapper', { 'is-open': !this.props.isOpen })}>
                    <a href="/">
                        {
                            this.props.isOpen ? (
                                <img src={cloudlogo} alt="mydigitaloffice" />
                            ) : (
                                <img src={logo} alt="mydigitaloffice" />
                                
                                )
                        }
                    </a>
                </div> */}
                
                <Menu
                    //defaultSelectedKeys={['dashboard']}
                    mode="inline"
                    theme="dark"
                    defaultOpenKeys={this.state.openedSubMenus}
                    selectedKeys={this.state.openedMenuItems}
                    forceSubMenuRender
                    // selectable
                >
                    {/* <Menu.Item key="dashboard" id="dashboard">
                        <NavLink 
                        to="/"
                        onClick={()=>this.pushopeneditems([],['dashboard'])}
                        >
                            <DesktopOutlined />
                            <span>Dashboard</span>
                        </NavLink>
                    </Menu.Item> */}
                    {(this.props.accessType != accessType.END_USER)?(
                            <Menu.Item key="filetrace">
                                <NavLink to="/filetrace">
                                    <FileSearchOutlined />
                                    <span>File Tracing</span>
                                </NavLink>
                            </Menu.Item>
                        ):""
                    }
                    {(this.props.doRender && this.props.accessType == accessType.END_USER) ? 
                        (<SessionData 
                            user={this.props.user} 
                            token={this.props.token} 
                            openedSubMenus={this.state.openedSubMenus}
                            openedMenuItems={this.state.openedMenuItems}
                            pushopeneditems={this.pushopeneditems} />) : ""}
                </Menu>
            </Sider>
        );

    }
}

export default SideBar;